export enum EventKind {
  EMPTY = 'empty',
  SERVER = 'server',
  NETWORK = 'network',
  PARSING = 'parsing',
}

export const EventEmptyOk: object[] = [{ key: 'traceId', value: '' }];

export const eventType: string = 'snowplow';
export const eventSchema: string = 'iglu:frontend-health/event/jsonschema/1-0-0';
